import { useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useTheme } from "@/context/ThemeContext";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Sun, Moon } from "lucide-react";
import { toast } from "sonner";

export default function Settings() {
    const { user } = useAuth();
    const { theme, setTheme } = useTheme();
    const [pw, setPw] = useState({ current_password: "", new_password: "" });

    const changePw = async (e) => {
        e.preventDefault();
        try {
            await api.post("/auth/change-password", pw);
            toast.success("Password updated");
            setPw({ current_password: "", new_password: "" });
        } catch (err) { toast.error(err.response?.data?.detail || "Failed"); }
    };

    return (
        <div className="space-y-6 max-w-3xl" data-testid="settings-page">
            <div>
                <div className="text-xs uppercase tracking-widest font-bold text-muted-foreground">Account</div>
                <h1 className="font-display text-3xl lg:text-4xl mt-1">Settings</h1>
            </div>
            <Tabs defaultValue="profile">
                <TabsList>
                    <TabsTrigger value="profile" data-testid="tab-profile">Profile</TabsTrigger>
                    <TabsTrigger value="security" data-testid="tab-security">Security</TabsTrigger>
                    <TabsTrigger value="preferences" data-testid="tab-prefs">Preferences</TabsTrigger>
                </TabsList>
                <TabsContent value="profile">
                    <Card className="mx-card"><CardContent className="p-6 space-y-3">
                        <div><Label>Name</Label><Input value={user?.name || ""} disabled /></div>
                        <div><Label>Email</Label><Input value={user?.email || ""} disabled /></div>
                        <div><Label>Role</Label><Input value={user?.role || ""} disabled /></div>
                    </CardContent></Card>
                </TabsContent>
                <TabsContent value="security">
                    <Card className="mx-card"><CardContent className="p-6">
                        <form onSubmit={changePw} className="space-y-3 max-w-sm">
                            <div><Label>Current password</Label><Input type="password" required value={pw.current_password} onChange={e => setPw({ ...pw, current_password: e.target.value })} data-testid="current-password-input" /></div>
                            <div><Label>New password</Label><Input type="password" required value={pw.new_password} onChange={e => setPw({ ...pw, new_password: e.target.value })} data-testid="new-password-input" /></div>
                            <Button type="submit" className="mx-btn-primary" data-testid="change-password-submit">Change password</Button>
                        </form>
                    </CardContent></Card>
                </TabsContent>
                <TabsContent value="preferences">
                    <Card className="mx-card"><CardContent className="p-6">
                        <Label className="mb-2 block">Appearance</Label>
                        <div className="flex gap-3">
                            <Button variant={theme === "light" ? "default" : "outline"} onClick={() => setTheme("light")} data-testid="theme-light"><Sun className="h-4 w-4 mr-2" /> Light</Button>
                            <Button variant={theme === "dark" ? "default" : "outline"} onClick={() => setTheme("dark")} data-testid="theme-dark"><Moon className="h-4 w-4 mr-2" /> Dark</Button>
                        </div>
                    </CardContent></Card>
                </TabsContent>
            </Tabs>
        </div>
    );
}
